// SupportBox.jsx
import React from "react";
import "../styles/RegulatoryCompliance.css";

const SupportBox = () => {
  return (
    <div className="support-box">
      <p>
        <strong>Customer Support:</strong>
        <br />info@nexagrowthafrica.com
      </p>
    </div>
  );
};

export default SupportBox;
